// Given a list of categories map each one to a unique color.
// As a heuristic, assign in order, so put high-frequency categories first
// to reduce coincidences..

export const getColorAssignments = (categories: string[]) => {
  const palette = ['#0076FF', '#29CD9C', '#C1EAD9', '#F8BB06', '#E8412A', '#6a5df9'];

  const assignments: Record<string, string> = {};

  let paletteIndex = 0;

  for (const category of categories) {
    assignments[category] = palette[paletteIndex];
    paletteIndex = (paletteIndex + 1) % palette.length;
  }

  return assignments;
};
